import { init } from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import App from "./App.svelte";

import Pages from "./routes/Pages.svelte";
import Login from "./routes/Login.svelte";
import Invalid from "./routes/Invalid.svelte";
import Recover from "./routes/Recover.svelte";

const re = /time2client.com/;

init({
  dsn: "https://1d37dbb17f2f4f0889c763091a31a37d@sentry.io/1815252",
  environment: re.exec(window.location.hostname) ? "prod" : "dev",

  // To set your release version
  release: "t2c-client-client@1.0.0",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const loginTarget = document.getElementById("login");
loginTarget
  ? new App({ target: loginTarget, props: { component: Login } })
  : null;

const recoverTarget = document.getElementById("recover");
recoverTarget
  ? new App({
      target: recoverTarget,
      props: { component: Recover, flow: "recover" },
    })
  : null;

const invalidTarget = document.getElementById("invalidOrExpiredToken");
invalidTarget
  ? new App({
      target: invalidTarget,
      props: { component: Invalid },
    })
  : null;

const confirmTarget = document.getElementById("confirm");
confirmTarget
  ? new App({
      target: confirmTarget,
      props: { component: Recover, flow: "confirm" },
    })
  : null;

const appTarget = document.getElementById("app");
appTarget ? new App({ target: appTarget, props: { component: Pages } }) : null;
